//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The classification of the notification (borrowed from Bootstrap) */
export const NotificationClassification = {
    /** The success */
    Success: 0,

    /** The information */
    Info: 1,

    /** The warning */
    Warning: 2,

    /** The danger */
    Danger: 3
} as const;

/** The classification of the notification (borrowed from Bootstrap) */
export const NotificationClassificationDescription: Record<number, string> = {
    0: "Success",

    1: "Info",

    2: "Warning",

    3: "Danger"
};

/** The classification of the notification (borrowed from Bootstrap) */
export type NotificationClassification = typeof NotificationClassification[keyof typeof NotificationClassification];
